<mat-card class="card-padding">
  <mat-card-content>
    <span class="subtitle" *ngIf="tier == ''">Before you can manage users, you first need to subscribe to a <a
        [routerLink]="['/billing']">plan</a>.
    </span>
    <mat-spinner *ngIf="users==null && tier != ''" diameter="70" style="margin: 50px auto 50px auto;"></mat-spinner>
    <div *ngIf="users!=null && tier != ''">
      <div *ngIf="users[0]==null" style="margin: 50px auto 50px auto; display: table;">
        <span>No users found</span>
      </div>

      <div *ngIf="users[0]!=null">
        <table *ngIf="users.length>0 && tier != 126" class="users-table">
          <tr class="users-row">
            <td class="users-head">Email Address</td>
            <td class="users-head"></td>
          </tr>
          <tr *ngFor="let user of users" class="users-row">
            <td class="users-cell">{{user.UserEmail}}</td>
            <td class="users-cell">
              <button mat-stroked-button style="color: #1A47D6; border-color: #1A47D6; max-width: 200px; width: 100%;    float: right;
                  margin-right: 24px;" (click)="deleteUser(user.UserName,user.UserEmail)"
                *ngIf="user.IsPausedFlag=='N' && user.PausedCount<5 ">
                Suspend
              </button>
            </td>
            <td class="user-overlay" *ngIf="user.IsPausedFlag=='Y'"> This user is suspended.</td>
          </tr>
        </table>

        <table *ngIf="users.length>0 && tier == 126" class="users-table">
          <tr class="users-row">
            <td class="users-head">Email Address</td>

            <td class="users-head">
              <div style="display: grid; grid-auto-flow: column; grid-template-columns: 0.3fr 0.3fr 0.3fr;">
                <div class="users-subhead users-border" style="text-align: center;">TLS</div>
                <div class="users-subhead" style="text-align: center;">Delivery</div>
                <div class="users-subhead" style="text-align: center;">Communication</div>
              </div>
            </td>


          </tr>
          <tr *ngFor="let user of users" [ngClass]="[(user.IsPausedFlag=='Y')? 'users-rows':'users-row']">
            <td class="users-cell">{{user.UserEmail}}</td>
            <td class="users-cell">
              <div id="check" class="users-div">
                <div class="users-subhead users-border" style="text-align: center;">
                  <button mat-icon-button *ngIf="user.TLS=='Y'"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button *ngIf="user.TLS=='N'"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
                <div class="users-subhead" style="text-align: center;">
                  <button mat-icon-button
                    *ngIf="(user.E=='Y' && user.EIsPausedFlag=='N')"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button
                    *ngIf="!(user.E=='Y' && user.EIsPausedFlag=='N')"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
                <div class="users-subhead" style="text-align: center;">
                  <button mat-icon-button
                    *ngIf="(user.D=='Y' && user.DIsPausedFlag=='N')"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button
                    *ngIf="!(user.D=='Y' && user.DIsPausedFlag=='N')"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
              </div>
              <div *ngIf="user.IsPausedFlag=='N' && user.PausedCount<5 " class="button-padding" id="pause">
                <div class="users-subhead users-border" style="text-align: center;">
                  <button mat-icon-button *ngIf="user.TLS=='Y'"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button *ngIf="user.TLS=='N'"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
                <button mat-stroked-button
                  style="color: #1A47D6; border-color: #1A47D6; max-width: 200px; width: 100%; height: 34px;"
                  (click)="deleteUser(user.UserName,user.UserEmail)">
                  Downgrade
                </button>
              </div>
              <div *ngIf="user.IsPausedFlag=='N' && user.PausedCount==null " class="users-div" id="pause">
                <div class="users-subhead users-border" style="text-align: center;">
                  <button mat-icon-button *ngIf="user.TLS=='Y'"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button *ngIf="user.TLS=='N'"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
                <div class="users-subhead" style="text-align: center;">
                  <button mat-icon-button
                    *ngIf="(user.E=='Y' && user.EIsPausedFlag=='N')"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button
                    *ngIf="!(user.E=='Y' && user.EIsPausedFlag=='N')"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
                <div class="users-subhead" style="text-align: center;">
                  <button mat-icon-button
                    *ngIf="(user.D=='Y' && user.DIsPausedFlag=='N')"><mat-icon>done</mat-icon></button>
                  <button mat-icon-button
                    *ngIf="!(user.D=='Y' && user.DIsPausedFlag=='N')"><mat-icon style="color: rgba(0, 0, 0, .54);">horizontal_rule</mat-icon></button>
                </div>
              </div>
            </td>


            <!-- <td class="user-overlay" *ngIf="user.IsPausedFlag=='Y'"> This user is suspended.</td> -->
          </tr>
        </table>
      </div>
    </div>

  </mat-card-content>
</mat-card>

<!-- <button mat-stroked-button style="max-width: 200px; width: 100%;"  disabled *ngIf="user.IsPausedFlag=='N' && user.PausedCount>=5 ">
                  Suspend
              </button> -->
<!-- <button mat-icon-button (click)="deleteUser(user.UserName,user.UserEmail)" *ngIf="user.IsPausedFlag=='N' && user.PausedCount<5 "><mat-icon>pause</mat-icon></button> -->


<!-- <td>
                    <td class="users-cell"*ngIf="tier == 120 || tier == 124">
                        <button mat-icon-button *ngIf="user.IsPausedFlag=='N' && user.PausedCount==5"><mat-icon>done</mat-icon></button>
                        <button mat-icon-button *ngIf="user.IsPausedFlag=='Y' && user.PausedCount==5"><mat-icon>close</mat-icon></button>
                        <button mat-icon-button id="check" *ngIf="user.IsPausedFlag=='N' && user.PausedCount<5"><mat-icon>done</mat-icon></button>
                        <button mat-icon-button id="check" *ngIf="user.IsPausedFlag=='Y' && user.PausedCount<5"><mat-icon>close</mat-icon></button>
                        <button mat-icon-button id="pause" (click)="deleteUser(user.UserName)" *ngIf="user.IsPausedFlag=='N' && user.PausedCount<5"><mat-icon>pause</mat-icon></button>
                    </td>
                    <td class="users-cell"*ngIf="tier == 122 || tier == 124">
                        <button mat-icon-button *ngIf="user.IsDocPausedFlag=='N' && user.DocPausedCount==5"><mat-icon>done</mat-icon></button>
                        <button mat-icon-button *ngIf="(user.IsDocPausedFlag==null || user.IsDocPausedFlag=='Y') && user.DocPausedCount==5"><mat-icon>close</mat-icon></button>
                        <button mat-icon-button id="check" *ngIf="user.IsDocPausedFlag=='N' && user.DocPausedCount<5"><mat-icon>done</mat-icon></button>{{user.IsDocPausedFlag}}
                        <button mat-icon-button id="check" *ngIf="(user.IsDocPausedFlag==null || user.IsDocPausedFlag=='Y') && user.DocPausedCount<5"><mat-icon>close</mat-icon></button>
                    </td>
                </td> -->